module.exports = __webpack_public_path__ + "fonts/Graphik-Black.e04ab03f.woff2";